enum AttachmentTaskType {
    Client = 1,
    Analysis = 2,
    Solution = 3,
    PostService = 4
}

export default AttachmentTaskType;